import 'mapbox-gl/dist/mapbox-gl.css'
import 'react-responsive-carousel/lib/styles/carousel.min.css'

import Router from 'core/Router'

import { GlobalStyle } from './styles'

function App() {
	return (
		<>
			<GlobalStyle />
			<Router />
		</>
	)
}

export default App
